import { render, staticRenderFns } from "./memberConfig.vue?vue&type=template&id=63db28c6&"
import script from "./memberConfig.vue?vue&type=script&lang=js&"
export * from "./memberConfig.vue?vue&type=script&lang=js&"
import style0 from "./memberConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports